import React, { useEffect } from "react";
import "./Balance_Cards.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { GETAuthUser } from "../../../../../../features/webisite/auth/slice";
import { formatAmount } from "../../../../../../utils/common";

const Balance_Cards = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.WebMasters.auth);

  useEffect(() => {
    dispatch(GETAuthUser());
  }, [dispatch]);

  return (
    <div className="balance-wrapper">
      <div className="container">
        <div className="row g-4">
          <div className="col-xxl-8">
            <div className="row g-4">
              <div className="col-sm-6">
                <div
                  className="balance-card green"
                  onClick={() => navigate("/parties?filter=to_collect")}
                >
                  <div className="icon stack-icon">
                    <img
                      src="/Assets/Images/balance_cards/to-collect.png"
                      alt="rupee"
                    />
                  </div>

                  <div className="content">
                    <h3>
                      ₹{" "}
                      {formatAmount(
                        user?.data?.settlements_summary?.total_to_collect
                      ) || "0"}
                    </h3>
                    <p>To Collect</p>
                  </div>

                  <div className="arrow">
                    <FontAwesomeIcon icon={faChevronRight} />
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <div
                  className="balance-card red"
                  onClick={() => navigate("/parties?filter=to_pay")}
                >
                  <div className="icon">
                    <img
                      src="/Assets/Images/balance_cards/to-pay.png"
                      alt="logo"
                    />
                  </div>

                  <div className="content">
                    <h3>
                      ₹{" "}
                      {formatAmount(
                        user?.data?.settlements_summary?.total_to_pay
                      ) || "0"}
                    </h3>
                    <p>To Pay</p>
                  </div>

                  <div className="arrow">
                    <FontAwesomeIcon icon={faChevronRight} />
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <div
                  className="balance-card dark"
                  onClick={() => navigate("/stock-value")}
                >
                  <div className="icon">
                    <img
                      src="/Assets/Images/balance_cards/stock_quantity.png"
                      alt="stock"
                    />
                  </div>

                  <div className="content">
                    <p className="bold">Stock Value / Quantity</p>
                    <p>Value of Items</p>
                  </div>

                  <div className="arrow">
                    <FontAwesomeIcon icon={faChevronRight} />
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <div
                  className="balance-card grey"
                  onClick={() => navigate("/this-weeks-sale")}
                >
                  <div className="icon stack-icon">
                    {/* <img
                      src="/Assets/Images/balance_cards/circle.png"
                      alt="Background"
                    /> */}
                    <img
                      src="/Assets/Images/balance_cards/funds.png"
                      alt="Chart"
                      className="inner-chart"
                    />
                  </div>

                  <div className="content">
                    <h3>
                      ₹{" "}
                      {formatAmount(user?.data?.sales_summary?.total_sales) ||
                        "0"}
                    </h3>
                    <p>This Week's Sale</p>
                  </div>

                  <div className="arrow">
                    <FontAwesomeIcon icon={faChevronRight} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xxl-4 col-sm-6">
            <div
              className="balance-card ledger tall h-100 clickable"
              onClick={() => navigate("/ledger-balance")}
            >
              <div className="icon">
                <img
                  src="/Assets/Images/balance_cards/Rupee.png"
                  alt="Ledger Balance"
                />
              </div>
              <div className="content_upper_div">
                <h3>Ledger Balance</h3>
                <div className="content_lower">
                  <p className="inner_text">Cash and Bank Balance</p>
                  <div className="arrow">
                    <FontAwesomeIcon icon={faChevronRight} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Balance_Cards;
